// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// AUTO-GENERATED — do not edit manually.
// Source: back/data/data-model-schema.json
// Regenerate: node scripts/generate-ontology-vocabulary.mjs

export type EntityTypeName =
  | 'AHU'
  | 'ATSType'
  | 'AggregatePoint'
  | 'Air_Cooled_Chiller'
  | 'Air_Flow_CapacityQuantityShape'
  | 'Air_Handling_Unit'
  | 'Air_Header'
  | 'BACnetObjects'
  | 'BESSType'
  | 'BMSType'
  | 'BatteryMetricsType'
  | 'BatteryRoom'
  | 'BatteryStringMetricsType'
  | 'BuswayType'
  | 'CRAH'
  | 'CellMetricsType'
  | 'ChargeEfficiency'
  | 'Chilled_Water_Loop'
  | 'Chilled_Water_Pump'
  | 'Chilled_Water_Thermal_Energy_Storage_Tank'
  | 'Chiller'
  | 'Chiller_Plant'
  | 'Chiller_Plant_Header'
  | 'Coefficient_Of_Performance_Sensor'
  | 'Cold_Aisle'
  | 'CommunicationProtocolDoc'
  | 'Condenser_Water_Approach_Temperature_Sensor'
  | 'Condenser_Water_Pump'
  | 'Condensing_Unit'
  | 'ControllerType'
  | 'Cooling_Coil'
  | 'Cooling_Thermal_Power_Sensor'
  | 'Cooling_Tower'
  | 'Cooling_Tower_Fan'
  | 'DataHall'
  | 'DeviceType'
  | 'DischargeEfficiency'
  | 'Document'
  | 'Economizer'
  | 'ElectricalMeasurementsType'
  | 'ElectricalRoom'
  | 'Evaporator'
  | 'Fan'
  | 'Fan_Coil_Unit'
  | 'FeederType'
  | 'FirmwarePackage'
  | 'GatewayType'
  | 'GeneratorRoom'
  | 'GeneratorSetType'
  | 'GeneratorYard'
  | 'GroundingNetworkType'
  | 'HVACZone'
  | 'HVAC_Equipment'
  | 'Hot_Aisle'
  | 'ITRackType'
  | 'IT_Rack'
  | 'InstallationGuide'
  | 'KPI'
  | 'MCCType'
  | 'MOP'
  | 'MaintenanceHistory'
  | 'MaintenanceSchedule'
  | 'Max_Supply_Air_Temperature_Ramp_Rate'
  | 'Max_Supply_Water_Temperature_Ramp_Rate'
  | 'Max_Temperature_Operational_Limit'
  | 'Max_Water_Flow_Setpoint_Limit'
  | 'Mechanical_Room'
  | 'Min_Temperature_Operational_Limit'
  | 'Min_Water_Approach_Temperature_Limit'
  | 'Min_Water_Flow_Setpoint_Limit'
  | 'ModbusMap'
  | 'MotorFeederType'
  | 'OPCUAModel'
  | 'Outside_Damper'
  | 'PDUType'
  | 'PQMeterType'
  | 'PanelboardType'
  | 'Phase'
  | 'PointOfInterconnection'
  | 'PowerDeviceType'
  | 'RPPType'
  | 'RackPDUType'
  | 'Rooftop_Unit'
  | 'SOP'
  | 'SPDType'
  | 'STSType'
  | 'SiteType'
  | 'SoH'
  | 'Supply_Fan'
  | 'SwitchgearType'
  | 'THDI'
  | 'THDV'
  | 'TechnicalSpecifications'
  | 'TelemetryPoint'
  | 'TelemetryStream'
  | 'TransformerType'
  | 'UPSType'
  | 'UserManual'
  | 'UtilityMeterType'
  | 'ValueStream'
  | 'Water_Flow_CapacityQuantityShape'
  | 'WiringDiagram';

export const ENTITY_TYPE_NAMES: readonly EntityTypeName[] = [
  'AHU',
  'ATSType',
  'AggregatePoint',
  'Air_Cooled_Chiller',
  'Air_Flow_CapacityQuantityShape',
  'Air_Handling_Unit',
  'Air_Header',
  'BACnetObjects',
  'BESSType',
  'BMSType',
  'BatteryMetricsType',
  'BatteryRoom',
  'BatteryStringMetricsType',
  'BuswayType',
  'CRAH',
  'CellMetricsType',
  'ChargeEfficiency',
  'Chilled_Water_Loop',
  'Chilled_Water_Pump',
  'Chilled_Water_Thermal_Energy_Storage_Tank',
  'Chiller',
  'Chiller_Plant',
  'Chiller_Plant_Header',
  'Coefficient_Of_Performance_Sensor',
  'Cold_Aisle',
  'CommunicationProtocolDoc',
  'Condenser_Water_Approach_Temperature_Sensor',
  'Condenser_Water_Pump',
  'Condensing_Unit',
  'ControllerType',
  'Cooling_Coil',
  'Cooling_Thermal_Power_Sensor',
  'Cooling_Tower',
  'Cooling_Tower_Fan',
  'DataHall',
  'DeviceType',
  'DischargeEfficiency',
  'Document',
  'Economizer',
  'ElectricalMeasurementsType',
  'ElectricalRoom',
  'Evaporator',
  'Fan',
  'Fan_Coil_Unit',
  'FeederType',
  'FirmwarePackage',
  'GatewayType',
  'GeneratorRoom',
  'GeneratorSetType',
  'GeneratorYard',
  'GroundingNetworkType',
  'HVACZone',
  'HVAC_Equipment',
  'Hot_Aisle',
  'ITRackType',
  'IT_Rack',
  'InstallationGuide',
  'KPI',
  'MCCType',
  'MOP',
  'MaintenanceHistory',
  'MaintenanceSchedule',
  'Max_Supply_Air_Temperature_Ramp_Rate',
  'Max_Supply_Water_Temperature_Ramp_Rate',
  'Max_Temperature_Operational_Limit',
  'Max_Water_Flow_Setpoint_Limit',
  'Mechanical_Room',
  'Min_Temperature_Operational_Limit',
  'Min_Water_Approach_Temperature_Limit',
  'Min_Water_Flow_Setpoint_Limit',
  'ModbusMap',
  'MotorFeederType',
  'OPCUAModel',
  'Outside_Damper',
  'PDUType',
  'PQMeterType',
  'PanelboardType',
  'Phase',
  'PointOfInterconnection',
  'PowerDeviceType',
  'RPPType',
  'RackPDUType',
  'Rooftop_Unit',
  'SOP',
  'SPDType',
  'STSType',
  'SiteType',
  'SoH',
  'Supply_Fan',
  'SwitchgearType',
  'THDI',
  'THDV',
  'TechnicalSpecifications',
  'TelemetryPoint',
  'TelemetryStream',
  'TransformerType',
  'UPSType',
  'UserManual',
  'UtilityMeterType',
  'ValueStream',
  'Water_Flow_CapacityQuantityShape',
  'WiringDiagram',
] as const;

export type MeasurementName =
  | 'ATSTransferCount'
  | 'ActiveEnergy'
  | 'ActivePower'
  | 'ActivePowerSetpoint'
  | 'ApparentPower'
  | 'BypassActivePower'
  | 'CellTemperature'
  | 'ChargePowerSetpoint'
  | 'Chilled_Water_Flow_Sensor'
  | 'Chilled_Water_Flow_Setpoint'
  | 'Chilled_Water_Return_Temperature_Sensor'
  | 'Chilled_Water_Supply_Temperature_Sensor'
  | 'Condenser_Water_Flow_Sensor'
  | 'Condenser_Water_Flow_Setpoint'
  | 'Current'
  | 'DCCurrent'
  | 'DCVoltage'
  | 'DischargePowerSetpoint'
  | 'Electric_Power_Sensor'
  | 'EnergyAvailable'
  | 'EngineCoolantTemperature'
  | 'EngineOilPressure'
  | 'EngineRPM'
  | 'Entering_Condenser_Water_Temperature_Sensor'
  | 'ExportActiveEnergy'
  | 'ExportActivePower'
  | 'ExportActivePowerL1'
  | 'ExportActivePowerL2'
  | 'ExportActivePowerL3'
  | 'Frequency'
  | 'FuelLevel'
  | 'HarmonicsI'
  | 'HarmonicsV'
  | 'Humidity'
  | 'ImportActiveEnergy'
  | 'ImportActivePower'
  | 'ImportActivePowerL1'
  | 'ImportActivePowerL2'
  | 'ImportActivePowerL3'
  | 'InputApparentPower'
  | 'InputApparentPowerL1'
  | 'InputApparentPowerL2'
  | 'InputApparentPowerL3'
  | 'InputCurrent'
  | 'InputCurrentL1'
  | 'InputCurrentL2'
  | 'InputCurrentL3'
  | 'InputVoltageL1L2'
  | 'InputVoltageL1N'
  | 'InputVoltageL2L3'
  | 'InputVoltageL2N'
  | 'InputVoltageL3L1'
  | 'InputVoltageL3N'
  | 'InputVoltageLL'
  | 'InputVoltageLN'
  | 'Leaving_Condenser_Water_Temperature_Sensor'
  | 'Leaving_Condenser_Water_Temperature_Setpoint'
  | 'LoadingPercentage'
  | 'MaxSOC'
  | 'MinSOC'
  | 'Mixed_Air_Temperature_Sensor'
  | 'Mixed_Air_Temperature_Setpoint'
  | 'OutputApparentPower'
  | 'OutputApparentPowerL1'
  | 'OutputApparentPowerL2'
  | 'OutputApparentPowerL3'
  | 'OutputCurrent'
  | 'OutputCurrentL1'
  | 'OutputCurrentL2'
  | 'OutputCurrentL3'
  | 'OutputVoltageL1L2'
  | 'OutputVoltageL1N'
  | 'OutputVoltageL2L3'
  | 'OutputVoltageL2N'
  | 'OutputVoltageL3L1'
  | 'OutputVoltageL3N'
  | 'OutputVoltageLL'
  | 'OutputVoltageLN'
  | 'Outside_Air_Temperature_Sensor'
  | 'PercentZ'
  | 'PowerFactor'
  | 'Power_Sensor'
  | 'PrimaryKV'
  | 'ReactivePower'
  | 'RemainingTime'
  | 'Return_Air_Temperature_Sensor'
  | 'SecondaryKV'
  | 'SoC'
  | 'Speed_Setpoint'
  | 'Supply_Air_Flow_Sensor'
  | 'Supply_Air_Flow_Setpoint'
  | 'Supply_Air_Temperature_Sensor'
  | 'Supply_Air_Temperature_Setpoint'
  | 'Supply_Chilled_Water_Temperature_Setpoint'
  | 'Temperature'
  | 'Voltage'
  | 'Zone_Air_Temperature_Sensor';

export const MEASUREMENT_NAMES: readonly MeasurementName[] = [
  'ATSTransferCount',
  'ActiveEnergy',
  'ActivePower',
  'ActivePowerSetpoint',
  'ApparentPower',
  'BypassActivePower',
  'CellTemperature',
  'ChargePowerSetpoint',
  'Chilled_Water_Flow_Sensor',
  'Chilled_Water_Flow_Setpoint',
  'Chilled_Water_Return_Temperature_Sensor',
  'Chilled_Water_Supply_Temperature_Sensor',
  'Condenser_Water_Flow_Sensor',
  'Condenser_Water_Flow_Setpoint',
  'Current',
  'DCCurrent',
  'DCVoltage',
  'DischargePowerSetpoint',
  'Electric_Power_Sensor',
  'EnergyAvailable',
  'EngineCoolantTemperature',
  'EngineOilPressure',
  'EngineRPM',
  'Entering_Condenser_Water_Temperature_Sensor',
  'ExportActiveEnergy',
  'ExportActivePower',
  'ExportActivePowerL1',
  'ExportActivePowerL2',
  'ExportActivePowerL3',
  'Frequency',
  'FuelLevel',
  'HarmonicsI',
  'HarmonicsV',
  'Humidity',
  'ImportActiveEnergy',
  'ImportActivePower',
  'ImportActivePowerL1',
  'ImportActivePowerL2',
  'ImportActivePowerL3',
  'InputApparentPower',
  'InputApparentPowerL1',
  'InputApparentPowerL2',
  'InputApparentPowerL3',
  'InputCurrent',
  'InputCurrentL1',
  'InputCurrentL2',
  'InputCurrentL3',
  'InputVoltageL1L2',
  'InputVoltageL1N',
  'InputVoltageL2L3',
  'InputVoltageL2N',
  'InputVoltageL3L1',
  'InputVoltageL3N',
  'InputVoltageLL',
  'InputVoltageLN',
  'Leaving_Condenser_Water_Temperature_Sensor',
  'Leaving_Condenser_Water_Temperature_Setpoint',
  'LoadingPercentage',
  'MaxSOC',
  'MinSOC',
  'Mixed_Air_Temperature_Sensor',
  'Mixed_Air_Temperature_Setpoint',
  'OutputApparentPower',
  'OutputApparentPowerL1',
  'OutputApparentPowerL2',
  'OutputApparentPowerL3',
  'OutputCurrent',
  'OutputCurrentL1',
  'OutputCurrentL2',
  'OutputCurrentL3',
  'OutputVoltageL1L2',
  'OutputVoltageL1N',
  'OutputVoltageL2L3',
  'OutputVoltageL2N',
  'OutputVoltageL3L1',
  'OutputVoltageL3N',
  'OutputVoltageLL',
  'OutputVoltageLN',
  'Outside_Air_Temperature_Sensor',
  'PercentZ',
  'PowerFactor',
  'Power_Sensor',
  'PrimaryKV',
  'ReactivePower',
  'RemainingTime',
  'Return_Air_Temperature_Sensor',
  'SecondaryKV',
  'SoC',
  'Speed_Setpoint',
  'Supply_Air_Flow_Sensor',
  'Supply_Air_Flow_Setpoint',
  'Supply_Air_Temperature_Sensor',
  'Supply_Air_Temperature_Setpoint',
  'Supply_Chilled_Water_Temperature_Setpoint',
  'Temperature',
  'Voltage',
  'Zone_Air_Temperature_Sensor',
] as const;

export type RelationshipTypeName =
  | 'aggregatesClass'
  | 'backupSource'
  | 'connectedFrom'
  | 'connectedTo'
  | 'containsEquipment'
  | 'controlledBy'
  | 'controls'
  | 'fedBy'
  | 'feeds'
  | 'hasDocument'
  | 'hasLocation'
  | 'hasParameter'
  | 'hasPhase'
  | 'hasPointOfInterconnection'
  | 'hasSOP'
  | 'hasTelemetryPoint'
  | 'hasTelemetryStream'
  | 'hasValueStream'
  | 'isLocationOf'
  | 'isParameterOf'
  | 'isTelemetryOf'
  | 'isTelemetryStreamOf'
  | 'primarySource'
  | 'protectedBy'
  | 'protects'
  | 'suppliedBy'
  | 'suppliesPowerTo';

export const RELATIONSHIP_TYPE_NAMES: readonly RelationshipTypeName[] = [
  'aggregatesClass',
  'backupSource',
  'connectedFrom',
  'connectedTo',
  'containsEquipment',
  'controlledBy',
  'controls',
  'fedBy',
  'feeds',
  'hasDocument',
  'hasLocation',
  'hasParameter',
  'hasPhase',
  'hasPointOfInterconnection',
  'hasSOP',
  'hasTelemetryPoint',
  'hasTelemetryStream',
  'hasValueStream',
  'isLocationOf',
  'isParameterOf',
  'isTelemetryOf',
  'isTelemetryStreamOf',
  'primarySource',
  'protectedBy',
  'protects',
  'suppliedBy',
  'suppliesPowerTo',
] as const;

export type UnitCode =
  | 'A'
  | 'BFT'
  | 'COUNT'
  | 'DAY'
  | 'DEG-PER-HR'
  | 'DEG-PER-MIN'
  | 'DEG-PER-SEC'
  | 'DEG_C'
  | 'DEG_F'
  | 'DEG_R'
  | 'FT-PER-HR'
  | 'FT-PER-SEC'
  | 'FT3-PER-MIN-FT2'
  | 'GigaHZ'
  | 'GigaHZ-M'
  | 'HR'
  | 'HZ'
  | 'HZ-M'
  | 'IN-PER-YR'
  | 'K'
  | 'KiloA'
  | 'KiloHZ'
  | 'KiloM-PER-HR'
  | 'KiloM-PER-SEC'
  | 'KiloV'
  | 'KiloVA'
  | 'KiloVAR'
  | 'KiloW'
  | 'KiloW-HR'
  | 'M-PER-HR'
  | 'M-PER-SEC'
  | 'MI-PER-HR'
  | 'MI-PER-SEC'
  | 'MIN'
  | 'MegaA'
  | 'MegaHZ'
  | 'MegaHZ-M'
  | 'MegaV'
  | 'MegaVA'
  | 'MegaVAR'
  | 'MegaW'
  | 'MegaW-HR'
  | 'MicroM-PER-MIN'
  | 'MicroM-PER-SEC'
  | 'MilliDEG_C'
  | 'PERCENT'
  | 'PERCENT_RH'
  | 'PSI'
  | 'PlanckTemperature'
  | 'RAD-PER-HR'
  | 'RAD-PER-MIN'
  | 'RAD-PER-SEC'
  | 'REV-PER-MIN'
  | 'SEC'
  | 'UNITLESS'
  | 'V'
  | 'VA'
  | 'VAR'
  | 'W'
  | 'W-HR'
  | 'YD-PER-HR'
  | 'YD-PER-MIN'
  | 'YD-PER-SEC';

export const UNIT_CODES: readonly UnitCode[] = [
  'A',
  'BFT',
  'COUNT',
  'DAY',
  'DEG-PER-HR',
  'DEG-PER-MIN',
  'DEG-PER-SEC',
  'DEG_C',
  'DEG_F',
  'DEG_R',
  'FT-PER-HR',
  'FT-PER-SEC',
  'FT3-PER-MIN-FT2',
  'GigaHZ',
  'GigaHZ-M',
  'HR',
  'HZ',
  'HZ-M',
  'IN-PER-YR',
  'K',
  'KiloA',
  'KiloHZ',
  'KiloM-PER-HR',
  'KiloM-PER-SEC',
  'KiloV',
  'KiloVA',
  'KiloVAR',
  'KiloW',
  'KiloW-HR',
  'M-PER-HR',
  'M-PER-SEC',
  'MI-PER-HR',
  'MI-PER-SEC',
  'MIN',
  'MegaA',
  'MegaHZ',
  'MegaHZ-M',
  'MegaV',
  'MegaVA',
  'MegaVAR',
  'MegaW',
  'MegaW-HR',
  'MicroM-PER-MIN',
  'MicroM-PER-SEC',
  'MilliDEG_C',
  'PERCENT',
  'PERCENT_RH',
  'PSI',
  'PlanckTemperature',
  'RAD-PER-HR',
  'RAD-PER-MIN',
  'RAD-PER-SEC',
  'REV-PER-MIN',
  'SEC',
  'UNITLESS',
  'V',
  'VA',
  'VAR',
  'W',
  'W-HR',
  'YD-PER-HR',
  'YD-PER-MIN',
  'YD-PER-SEC',
] as const;

export const RELATIONSHIP_INVERSE = {
  connectedFrom: 'connectedTo',
  connectedTo: 'connectedFrom',
  controlledBy: 'controls',
  controls: 'controlledBy',
  fedBy: 'feeds',
  feeds: 'fedBy',
  hasLocation: 'isLocationOf',
  hasParameter: 'isParameterOf',
  isLocationOf: 'hasLocation',
  isParameterOf: 'hasParameter',
  protectedBy: 'protects',
  protects: 'protectedBy',
  suppliedBy: 'suppliesPowerTo',
  suppliesPowerTo: 'suppliedBy',
} as const satisfies Partial<Record<RelationshipTypeName, RelationshipTypeName>>;

export const MEASUREMENT_UNITS = {
  ATSTransferCount: ['COUNT'],
  ActiveEnergy: ['KiloW-HR', 'MegaW-HR', 'W-HR'],
  ActivePower: ['KiloW', 'MegaW', 'W'],
  ActivePowerSetpoint: ['KiloW', 'MegaW', 'W'],
  ApparentPower: ['KiloVA', 'MegaVA', 'VA'],
  BypassActivePower: ['KiloW', 'MegaW', 'W'],
  CellTemperature: ['DEG_C', 'DEG_F', 'K'],
  ChargePowerSetpoint: ['KiloW', 'MegaW', 'W'],
  Current: ['A', 'KiloA', 'MegaA'],
  DCCurrent: ['A', 'KiloA', 'MegaA'],
  DCVoltage: ['KiloV', 'MegaV', 'V'],
  DischargePowerSetpoint: ['KiloW', 'MegaW', 'W'],
  EnergyAvailable: ['KiloW-HR', 'MegaW-HR', 'W-HR'],
  EngineCoolantTemperature: ['DEG_C', 'DEG_F', 'K'],
  EngineOilPressure: ['PSI'],
  EngineRPM: ['REV-PER-MIN'],
  Entering_Condenser_Water_Temperature_Sensor: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  ExportActiveEnergy: ['KiloW-HR', 'MegaW-HR', 'W-HR'],
  ExportActivePower: ['KiloW', 'MegaW', 'W'],
  ExportActivePowerL1: ['KiloW', 'MegaW', 'W'],
  ExportActivePowerL2: ['KiloW', 'MegaW', 'W'],
  ExportActivePowerL3: ['KiloW', 'MegaW', 'W'],
  Frequency: ['GigaHZ', 'HZ', 'KiloHZ', 'MegaHZ'],
  FuelLevel: ['PERCENT'],
  HarmonicsI: ['PERCENT'],
  HarmonicsV: ['PERCENT'],
  Humidity: ['PERCENT_RH'],
  ImportActiveEnergy: ['KiloW-HR', 'MegaW-HR', 'W-HR'],
  ImportActivePower: ['KiloW', 'MegaW', 'W'],
  ImportActivePowerL1: ['KiloW', 'MegaW', 'W'],
  ImportActivePowerL2: ['KiloW', 'MegaW', 'W'],
  ImportActivePowerL3: ['KiloW', 'MegaW', 'W'],
  InputApparentPower: ['KiloVA', 'MegaVA', 'VA'],
  InputApparentPowerL1: ['KiloVA', 'MegaVA', 'VA'],
  InputApparentPowerL2: ['KiloVA', 'MegaVA', 'VA'],
  InputApparentPowerL3: ['KiloVA', 'MegaVA', 'VA'],
  InputCurrent: ['A', 'KiloA', 'MegaA'],
  InputCurrentL1: ['A', 'KiloA', 'MegaA'],
  InputCurrentL2: ['A', 'KiloA', 'MegaA'],
  InputCurrentL3: ['A', 'KiloA', 'MegaA'],
  InputVoltageL1L2: ['KiloV', 'MegaV', 'V'],
  InputVoltageL1N: ['KiloV', 'MegaV', 'V'],
  InputVoltageL2L3: ['KiloV', 'MegaV', 'V'],
  InputVoltageL2N: ['KiloV', 'MegaV', 'V'],
  InputVoltageL3L1: ['KiloV', 'MegaV', 'V'],
  InputVoltageL3N: ['KiloV', 'MegaV', 'V'],
  InputVoltageLL: ['KiloV', 'MegaV', 'V'],
  InputVoltageLN: ['KiloV', 'MegaV', 'V'],
  Leaving_Condenser_Water_Temperature_Sensor: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  Leaving_Condenser_Water_Temperature_Setpoint: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  LoadingPercentage: ['PERCENT'],
  MaxSOC: ['PERCENT'],
  MinSOC: ['PERCENT'],
  Mixed_Air_Temperature_Sensor: ['DEG_C', 'DEG_F', 'DEG_R', 'K', 'MilliDEG_C', 'PlanckTemperature'],
  Mixed_Air_Temperature_Setpoint: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  OutputApparentPower: ['KiloVA', 'MegaVA', 'VA'],
  OutputApparentPowerL1: ['KiloVA', 'MegaVA', 'VA'],
  OutputApparentPowerL2: ['KiloVA', 'MegaVA', 'VA'],
  OutputApparentPowerL3: ['KiloVA', 'MegaVA', 'VA'],
  OutputCurrent: ['A', 'KiloA', 'MegaA'],
  OutputCurrentL1: ['A', 'KiloA', 'MegaA'],
  OutputCurrentL2: ['A', 'KiloA', 'MegaA'],
  OutputCurrentL3: ['A', 'KiloA', 'MegaA'],
  OutputVoltageL1L2: ['KiloV', 'MegaV', 'V'],
  OutputVoltageL1N: ['KiloV', 'MegaV', 'V'],
  OutputVoltageL2L3: ['KiloV', 'MegaV', 'V'],
  OutputVoltageL2N: ['KiloV', 'MegaV', 'V'],
  OutputVoltageL3L1: ['KiloV', 'MegaV', 'V'],
  OutputVoltageL3N: ['KiloV', 'MegaV', 'V'],
  OutputVoltageLL: ['KiloV', 'MegaV', 'V'],
  OutputVoltageLN: ['KiloV', 'MegaV', 'V'],
  Outside_Air_Temperature_Sensor: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  PercentZ: ['PERCENT'],
  PowerFactor: ['UNITLESS'],
  PrimaryKV: ['KiloV', 'MegaV', 'V'],
  ReactivePower: ['KiloVAR', 'MegaVAR', 'VAR'],
  RemainingTime: ['DAY', 'HR', 'MIN', 'SEC'],
  Return_Air_Temperature_Sensor: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  SecondaryKV: ['KiloV', 'MegaV', 'V'],
  SoC: ['PERCENT'],
  Speed_Setpoint: [
    'BFT',
    'DEG-PER-HR',
    'DEG-PER-MIN',
    'DEG-PER-SEC',
    'FT-PER-HR',
    'FT-PER-SEC',
    'FT3-PER-MIN-FT2',
    'GigaHZ-M',
    'HZ-M',
    'IN-PER-YR',
    'KiloM-PER-HR',
    'KiloM-PER-SEC',
    'M-PER-HR',
    'M-PER-SEC',
    'MI-PER-HR',
    'MI-PER-SEC',
    'MegaHZ-M',
    'MicroM-PER-MIN',
    'MicroM-PER-SEC',
    'RAD-PER-HR',
    'RAD-PER-MIN',
    'RAD-PER-SEC',
    'YD-PER-HR',
    'YD-PER-MIN',
    'YD-PER-SEC',
  ],
  Supply_Air_Temperature_Sensor: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  Supply_Air_Temperature_Setpoint: [
    'DEG_C',
    'DEG_F',
    'DEG_R',
    'K',
    'MilliDEG_C',
    'PlanckTemperature',
  ],
  Temperature: ['DEG_C', 'DEG_F', 'K'],
  Voltage: ['KiloV', 'MegaV', 'V'],
  Zone_Air_Temperature_Sensor: ['DEG_C', 'DEG_F', 'DEG_R', 'K', 'MilliDEG_C', 'PlanckTemperature'],
} as const satisfies Partial<Record<MeasurementName, readonly UnitCode[]>>;

export type BreakerState = 'Closed' | 'Intermediate' | 'Open' | 'Tripped' | 'Unknown';

export type DeviceState = 'Faulted' | 'Maintenance' | 'Running' | 'Standby' | 'Stopped' | 'Unknown';

export type Source = 'BESS' | 'Bypass' | 'Generator' | 'UPS' | 'Utility';

export type UPSMode = 'Bypass' | 'Eco' | 'Fault' | 'OnBattery' | 'Online' | 'Standby';

export type ATSMode = 'Auto' | 'LockedOut' | 'Manual' | 'Test';

export type GenMode =
  | 'Cooldown'
  | 'Fault'
  | 'Ready'
  | 'Running'
  | 'Starting'
  | 'Stopped'
  | 'Testing';

export type BatteryChemistry = 'LFP' | 'LeadAcid' | 'NCA' | 'NMC' | 'Other';

export type ThyristorHealth = 'Fair' | 'Good' | 'Poor';

export type MotorFeederStarterState = 'Off' | 'Run' | 'Trip';

export type UPSAlarmStatus = 'Alarm' | 'Critical' | 'Normal' | 'Warning';

export type GenAlarmStatus = 'Alarm' | 'Critical' | 'Normal' | 'Shutdown' | 'Warning';

export type BESSAlarmStatus = 'Alarm' | 'Critical' | 'Fault' | 'Normal' | 'Warning';

export type ATSAlarmStatus = 'Alarm' | 'Critical' | 'Normal' | 'Warning';

export type BreakerTripCause =
  | 'GroundFault'
  | 'Manual'
  | 'None'
  | 'Other'
  | 'Overload'
  | 'Overvoltage'
  | 'ShortCircuit'
  | 'Undervoltage';

export type ValueStreamProgram =
  | 'ITC'
  | 'MA Clean Peak'
  | 'SGIP'
  | 'Tariff Based Demand Charge Management'
  | 'Tariff Based Energy Arbitrage';

export const ONTOLOGY_ENUM_VALUES = {
  ATSAlarmStatusEnum: ['Alarm', 'Critical', 'Normal', 'Warning'],
  ATSModeEnum: ['Auto', 'LockedOut', 'Manual', 'Test'],
  BESSAlarmStatusEnum: ['Alarm', 'Critical', 'Fault', 'Normal', 'Warning'],
  BatteryChemistryEnum: ['LFP', 'LeadAcid', 'NCA', 'NMC', 'Other'],
  BreakerStateEnum: ['Closed', 'Intermediate', 'Open', 'Tripped', 'Unknown'],
  BreakerTripCauseEnum: [
    'GroundFault',
    'Manual',
    'None',
    'Other',
    'Overload',
    'Overvoltage',
    'ShortCircuit',
    'Undervoltage',
  ],
  DeviceStateEnum: ['Faulted', 'Maintenance', 'Running', 'Standby', 'Stopped', 'Unknown'],
  GenAlarmStatusEnum: ['Alarm', 'Critical', 'Normal', 'Shutdown', 'Warning'],
  GenModeEnum: ['Cooldown', 'Fault', 'Ready', 'Running', 'Starting', 'Stopped', 'Testing'],
  MotorFeederStarterStateEnum: ['Off', 'Run', 'Trip'],
  SourceEnum: ['BESS', 'Bypass', 'Generator', 'UPS', 'Utility'],
  ThyristorHealthEnum: ['Fair', 'Good', 'Poor'],
  UPSAlarmStatusEnum: ['Alarm', 'Critical', 'Normal', 'Warning'],
  UPSModeEnum: ['Bypass', 'Eco', 'Fault', 'OnBattery', 'Online', 'Standby'],
  ValueStreamProgramEnum: [
    'ITC',
    'MA Clean Peak',
    'SGIP',
    'Tariff Based Demand Charge Management',
    'Tariff Based Energy Arbitrage',
  ],
} as const satisfies Record<string, readonly string[]>;

export const DECLARED_ATTRIBUTES = {
  AHU: [
    'Mixed_Air_Temperature_Setpoint',
    'Supply_Air_Flow_Setpoint',
    'Supply_Air_Temperature_Setpoint',
    'hasPart',
  ],
  ATSType: [
    'assetId',
    'backupSource',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'numberOfPoles',
    'primarySource',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'transferTimeMS',
    'transferType',
    'upstreamId',
  ],
  AggregatePoint: ['aggregate', 'aggregatesClass', 'aggregationSemantics', 'hasPart'],
  Air_Cooled_Chiller: [
    'Supply_Chilled_Water_Temperature_Setpoint',
    'coolingCapacity',
    'hasPart',
    'manufacturer',
    'maximumPartLoadRatio',
    'minimumFlowFraction',
    'minimumPartLoadRatio',
    'model',
    'ratedPower',
    'suppliedBy',
    'upstreamId',
  ],
  Air_Handling_Unit: [
    'coolingCapacity',
    'manufacturer',
    'minimumFlowFraction',
    'model',
    'ratedAirFlowCapacity',
    'upstreamId',
  ],
  Air_Header: ['feeds', 'isFedBy', 'isPartOf', 'upstreamId'],
  BACnetObjects: ['documentFileName', 'documentUrl', 'documentVersion'],
  BESSType: [
    'assetId',
    'batteryStringCount',
    'batteryType',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'hasValueStream',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedStorageCapacity',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  BMSType: [
    'assetId',
    'connectedTo',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  BatteryRoom: ['containsEquipment', 'isLocationOf', 'upstreamId'],
  BuswayType: [
    'assetId',
    'connectedTo',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  CRAH: [
    'Chilled_Water_Flow_Setpoint',
    'Supply_Air_Flow_Setpoint',
    'Supply_Air_Temperature_Setpoint',
    'coolingCapacity',
    'hasPart',
    'manufacturer',
    'maxLoad',
    'minimumFlowFraction',
    'model',
    'suppliedBy',
    'upstreamId',
  ],
  ChargeEfficiency: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  Chilled_Water_Loop: ['hasPart', 'upstreamId'],
  Chilled_Water_Pump: [
    'Chilled_Water_Flow_Setpoint',
    'Speed_Setpoint',
    'manufacturer',
    'minimumFlowFraction',
    'model',
    'ratedHead',
    'ratedPower',
    'ratedPowerInput',
    'ratedVoltage',
    'ratedWaterFlowCapacity',
    'shutoffHeadFactor',
    'upstreamId',
  ],
  Chilled_Water_Thermal_Energy_Storage_Tank: ['manufacturer', 'model', 'upstreamId'],
  Chiller: [
    'Chilled_Water_Flow_Setpoint',
    'Supply_Chilled_Water_Temperature_Setpoint',
    'coolingCapacity',
    'minimumPartLoadRatio',
  ],
  Chiller_Plant: ['hasPart'],
  Chiller_Plant_Header: ['feeds', 'isFedBy', 'upstreamId'],
  Cold_Aisle: ['Zone_Air_Temperature_Sensor', 'isPartOf'],
  CommunicationProtocolDoc: ['documentFileName', 'documentUrl', 'documentVersion'],
  Condenser_Water_Pump: ['minimumFlowFraction', 'ratedPowerInput', 'ratedWaterFlowCapacity'],
  Condensing_Unit: ['manufacturer', 'model', 'suppliedBy', 'upstreamId'],
  ControllerType: [
    'assetId',
    'communicationProtocol',
    'connectedTo',
    'controls',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'ipAddress',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  Cooling_Coil: ['feeds', 'isFedBy', 'ratedPressureDrop', 'upstreamId'],
  Cooling_Tower: [
    'Condenser_Water_Flow_Setpoint',
    'Leaving_Condenser_Water_Temperature_Setpoint',
    'hasPart',
  ],
  Cooling_Tower_Fan: ['minimumFlowFraction', 'ratedAirFlowCapacity', 'ratedPowerInput'],
  DataHall: ['containsEquipment', 'isLocationOf', 'upstreamId'],
  DischargeEfficiency: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  Document: ['documentFileName', 'documentUrl', 'documentVersion'],
  ElectricalRoom: ['containsEquipment', 'isLocationOf', 'upstreamId'],
  Evaporator: ['feeds', 'isFedBy', 'ratedPressureDrop', 'ratedWaterFlowCapacity', 'upstreamId'],
  Fan: ['minimumFlowFraction', 'ratedAirFlowCapacity', 'ratedPowerInput'],
  Fan_Coil_Unit: ['coolingCapacity', 'manufacturer', 'model', 'ratedAirFlowCapacity', 'upstreamId'],
  FeederType: [
    'assetId',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasSOP',
    'manufacturer',
    'model',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  FirmwarePackage: ['documentFileName', 'documentUrl', 'documentVersion'],
  GatewayType: [
    'assetId',
    'communicationProtocol',
    'connectedTo',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'ipAddress',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  GeneratorRoom: ['containsEquipment', 'upstreamId'],
  GeneratorSetType: [
    'assetId',
    'connectedTo',
    'controlledBy',
    'feeds',
    'fuelTankCapacity',
    'fuelType',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliesPowerTo',
    'upstreamId',
  ],
  GeneratorYard: ['containsEquipment', 'upstreamId'],
  GroundingNetworkType: [
    'assetId',
    'hasDocument',
    'hasSOP',
    'manufacturer',
    'model',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  HVAC_Equipment: ['coolingCapacity', 'hasPart', 'manufacturer', 'model', 'upstreamId'],
  Hot_Aisle: ['Zone_Air_Temperature_Sensor', 'isPartOf'],
  ITRackType: [
    'assetId',
    'backupSource',
    'connectedTo',
    'fedBy',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'maxLoad',
    'model',
    'primarySource',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'upstreamId',
  ],
  InstallationGuide: ['documentFileName', 'documentUrl', 'documentVersion'],
  MCCType: [
    'assetId',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  MaintenanceHistory: ['documentFileName', 'documentUrl', 'documentVersion'],
  MaintenanceSchedule: ['documentFileName', 'documentUrl', 'documentVersion'],
  Mechanical_Room: ['upstreamId'],
  ModbusMap: ['documentFileName', 'documentUrl', 'documentVersion'],
  MotorFeederType: [
    'assetId',
    'controlledBy',
    'fedBy',
    'hasDocument',
    'hasSOP',
    'manufacturer',
    'model',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  OPCUAModel: ['documentFileName', 'documentUrl', 'documentVersion'],
  Outside_Damper: ['Damper_Position_Command'],
  PDUType: [
    'assetId',
    'backupSource',
    'circuitCount',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  PQMeterType: [
    'assetId',
    'connectedTo',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  PanelboardType: [
    'breakerCount',
    'busbarRating',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'ratedVoltage',
    'suppliesPowerTo',
    'upstreamId',
  ],
  PointOfInterconnection: [
    'exportLimitMax',
    'feeds',
    'hasValueStream',
    'importLimitMax',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedVoltage',
    'suppliesPowerTo',
    'upstreamId',
  ],
  PowerDeviceType: [
    'assetId',
    'hasDocument',
    'hasSOP',
    'manufacturer',
    'model',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
  ],
  RPPType: [
    'assetId',
    'backupSource',
    'circuitCount',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  RackPDUType: [
    'assetId',
    'backupSource',
    'circuitCount',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'outletCount',
    'primarySource',
    'protectedBy',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  Rooftop_Unit: [
    'coolingCapacity',
    'manufacturer',
    'minimumFlowFraction',
    'model',
    'ratedAirFlowCapacity',
    'upstreamId',
  ],
  SPDType: [
    'assetId',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'upstreamId',
  ],
  STSType: [
    'assetId',
    'backupSource',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'numberOfPoles',
    'primarySource',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'transferTimeMS',
    'transferType',
    'upstreamId',
  ],
  SiteType: [
    'containsEquipment',
    'hasPointOfInterconnection',
    'hasValueStream',
    'isLocationOf',
    'latitude',
    'longitude',
    'ownedBy',
    'siteId',
    'timeZone',
    'upstreamId',
  ],
  SoH: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  Supply_Fan: ['manufacturer', 'model', 'ratedAirFlowCapacity', 'ratedPower', 'upstreamId'],
  SwitchgearType: [
    'assetId',
    'backupSource',
    'breakerCount',
    'breakerType',
    'busbarRating',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'hasValueStream',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  THDI: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  THDV: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  TechnicalSpecifications: ['documentFileName', 'documentUrl', 'documentVersion'],
  TelemetryPoint: ['hasPhase', 'isTelemetryOf', 'pointName', 'upstreamId'],
  TelemetryStream: ['isTelemetryStreamOf', 'upstreamId'],
  TransformerType: [
    'assetId',
    'backupSource',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  UPSType: [
    'assetId',
    'backupSource',
    'batteryStringCount',
    'batteryType',
    'connectedTo',
    'controlledBy',
    'fedBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'manufacturer',
    'model',
    'primarySource',
    'protectedBy',
    'protects',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliedBy',
    'suppliesPowerTo',
    'upstreamId',
  ],
  UserManual: ['documentFileName', 'documentUrl', 'documentVersion'],
  UtilityMeterType: [
    'assetId',
    'connectedTo',
    'controlledBy',
    'feeds',
    'hasDocument',
    'hasLocation',
    'hasSOP',
    'hasValueStream',
    'manufacturer',
    'model',
    'protectedBy',
    'ratedCurrent',
    'ratedPower',
    'ratedVoltage',
    'serialNumber',
    'suppliesPowerTo',
    'upstreamId',
  ],
  WiringDiagram: ['documentFileName', 'documentUrl', 'documentVersion'],
} as const satisfies Partial<Record<EntityTypeName, readonly string[]>>;

export const DECLARED_MEASUREMENTS = {
  AHU: [
    'Cooling_Thermal_Power_Sensor',
    'Mixed_Air_Temperature_Sensor',
    'Mixed_Air_Temperature_Setpoint',
    'Outside_Air_Temperature_Sensor',
    'Return_Air_Temperature_Sensor',
    'Supply_Air_Flow_Sensor',
    'Supply_Air_Flow_Setpoint',
    'Supply_Air_Temperature_Sensor',
    'Supply_Air_Temperature_Setpoint',
  ],
  ATSType: ['ATSTransferCount', 'ActivePower', 'Voltage'],
  Air_Cooled_Chiller: ['Supply_Chilled_Water_Temperature_Setpoint'],
  BESSType: [
    'ActivePower',
    'ChargePowerSetpoint',
    'DischargePowerSetpoint',
    'EnergyAvailable',
    'MaxSOC',
    'MinSOC',
    'SoC',
    'Temperature',
    'Voltage',
  ],
  BuswayType: ['ActivePower', 'Current', 'ImportActivePower'],
  CRAH: [
    'Chilled_Water_Flow_Setpoint',
    'Supply_Air_Flow_Setpoint',
    'Supply_Air_Temperature_Setpoint',
  ],
  Chilled_Water_Pump: [
    'ActivePower',
    'Chilled_Water_Flow_Setpoint',
    'Electric_Power_Sensor',
    'Speed_Setpoint',
  ],
  Chiller: [
    'Chilled_Water_Flow_Sensor',
    'Chilled_Water_Flow_Setpoint',
    'Chilled_Water_Return_Temperature_Sensor',
    'Chilled_Water_Supply_Temperature_Sensor',
    'Coefficient_Of_Performance_Sensor',
    'Cooling_Thermal_Power_Sensor',
    'Electric_Power_Sensor',
    'Entering_Condenser_Water_Temperature_Sensor',
    'Supply_Chilled_Water_Temperature_Setpoint',
  ],
  Cold_Aisle: ['Zone_Air_Temperature_Sensor'],
  Condenser_Water_Pump: ['Electric_Power_Sensor'],
  Cooling_Tower: [
    'Condenser_Water_Approach_Temperature_Sensor',
    'Condenser_Water_Flow_Sensor',
    'Condenser_Water_Flow_Setpoint',
    'Leaving_Condenser_Water_Temperature_Sensor',
    'Leaving_Condenser_Water_Temperature_Setpoint',
  ],
  Cooling_Tower_Fan: ['Power_Sensor'],
  Fan: ['Power_Sensor'],
  FeederType: ['ActivePower', 'Current'],
  GeneratorSetType: [
    'ActivePower',
    'EngineCoolantTemperature',
    'EngineOilPressure',
    'EngineRPM',
    'ExportActivePower',
    'Frequency',
    'FuelLevel',
    'LoadingPercentage',
    'OutputVoltageLL',
  ],
  HVACZone: ['Zone_Air_Temperature_Sensor'],
  Hot_Aisle: ['Zone_Air_Temperature_Sensor'],
  ITRackType: ['ActivePower', 'Electric_Power_Sensor', 'Temperature'],
  PDUType: [
    'ActivePower',
    'ApparentPower',
    'Current',
    'ImportActivePower',
    'InputCurrent',
    'InputVoltageL1L2',
    'InputVoltageL2L3',
    'InputVoltageL3L1',
    'InputVoltageLL',
    'InputVoltageLN',
    'PowerFactor',
    'Voltage',
  ],
  PQMeterType: [
    'Current',
    'HarmonicsI',
    'HarmonicsV',
    'InputCurrent',
    'InputVoltageLL',
    'InputVoltageLN',
    'Voltage',
  ],
  PanelboardType: ['ActivePower', 'Current', 'Voltage'],
  RPPType: [
    'ActivePower',
    'ApparentPower',
    'Current',
    'ImportActivePower',
    'InputCurrent',
    'InputVoltageL1L2',
    'InputVoltageL2L3',
    'InputVoltageL3L1',
    'InputVoltageLL',
    'InputVoltageLN',
    'PowerFactor',
    'Voltage',
  ],
  RackPDUType: [
    'ActivePower',
    'ApparentPower',
    'Current',
    'ExportActivePower',
    'ImportActivePower',
    'InputCurrent',
    'InputVoltageL1L2',
    'InputVoltageL2L3',
    'InputVoltageL3L1',
    'InputVoltageLL',
    'InputVoltageLN',
    'PowerFactor',
    'Voltage',
  ],
  STSType: ['ATSTransferCount', 'ActivePower', 'Voltage'],
  SwitchgearType: [
    'ActivePower',
    'ApparentPower',
    'Current',
    'Frequency',
    'PowerFactor',
    'ReactivePower',
    'Voltage',
  ],
  TransformerType: ['ActivePower', 'PrimaryKV', 'SecondaryKV', 'Temperature'],
  UPSType: [
    'ActivePower',
    'Current',
    'ExportActivePower',
    'Frequency',
    'ImportActivePower',
    'InputCurrentL1',
    'InputCurrentL2',
    'InputCurrentL3',
    'InputVoltageL1L2',
    'InputVoltageL1N',
    'InputVoltageL2L3',
    'InputVoltageL2N',
    'InputVoltageL3L1',
    'InputVoltageL3N',
    'LoadingPercentage',
    'OutputCurrentL1',
    'OutputCurrentL2',
    'OutputCurrentL3',
    'OutputVoltageL1L2',
    'OutputVoltageL1N',
    'OutputVoltageL2L3',
    'OutputVoltageL2N',
    'OutputVoltageL3L1',
    'OutputVoltageL3N',
    'RemainingTime',
    'SoC',
    'Temperature',
    'Voltage',
  ],
  UtilityMeterType: [
    'ActiveEnergy',
    'ActivePower',
    'ApparentPower',
    'Current',
    'Frequency',
    'ImportActiveEnergy',
    'ImportActivePower',
    'PowerFactor',
    'Voltage',
  ],
} as const satisfies Partial<Record<EntityTypeName, readonly string[]>>;

/**
 * The attribute names `T` declares in the ontology.
 * `never` for a type that declares no attributes.
 */
export type AttributeNameOf<T extends EntityTypeName> = T extends keyof typeof DECLARED_ATTRIBUTES
  ? (typeof DECLARED_ATTRIBUTES)[T][number]
  : never;

/**
 * The state keys `T` declares in the ontology.
 *
 * Not every declared state key is a `MeasurementName`: a few Brick sensor
 * points are declared on a state object without a matching measurement
 * definition. Use `MeasurementNameOf` where only true measurements are wanted.
 */
export type StateKeyOf<T extends EntityTypeName> = T extends keyof typeof DECLARED_MEASUREMENTS
  ? (typeof DECLARED_MEASUREMENTS)[T][number]
  : never;

/** The declared state keys of `T` that are also ontology measurements. */
export type MeasurementNameOf<T extends EntityTypeName> = Extract<StateKeyOf<T>, MeasurementName>;

/**
 * The unit codes `M` declares. Falls back to `UnitCode` for the measurements
 * that declare no unit enum, so a unit-aware read stays usable for them.
 */
export type UnitOf<M extends MeasurementName> = M extends keyof typeof MEASUREMENT_UNITS
  ? (typeof MEASUREMENT_UNITS)[M][number]
  : UnitCode;

/** The declared inverse of `T`, or `undefined` where the ontology declares none. */
export type InverseOf<T extends RelationshipTypeName> = T extends keyof typeof RELATIONSHIP_INVERSE
  ? (typeof RELATIONSHIP_INVERSE)[T]
  : undefined;

/** The entity types that declare `K` in their state. */
export type EntityTypeDeclaring<K extends string> = {
  [T in EntityTypeName]: K extends StateKeyOf<T> ? T : never;
}[EntityTypeName];
